<template>
  <div class="status-register-config-main"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="configInfo">
      <AppScrollbar style="height: 100%">
        <div class="main-cont">
          <div class="setup-info">
            <div class="check-cont">
              <el-checkbox v-model="form.checked"
                           true-label="1"
                           false-label="0">启用学生信息注册<span class="tip-msg">（每学期自动开启）</span></el-checkbox>
            </div>
            <div class="steps-cont">
              <ul>
                <li>1、学生信息注册设置用于学校定期收集/更新学生重要信息；</li>
                <li>2、学生信息注册启用后，学生必须进行注册内容的填写或核对后，才能进入平台学习；</li>
              </ul>
            </div>
          </div>
          <div v-if="form.checked === '1'"
               class="config-info">
            <div class="config-form">
              <el-form size="mini"
                       label-width="90px">
                <el-form-item label="设置注册时间"
                              class="required">
                  <div class="date-range">
                    <el-date-picker v-model="form.startDate"
                                    type="date"
                                    prefix-icon="el-icon-date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="请选择开始日期"
                                    :picker-options="{disabledDate: disabledStartDate}">
                    </el-date-picker>
                    <div class="divider">至</div>
                    <el-date-picker v-model="form.endDate"
                                    type="date"
                                    prefix-icon="el-icon-date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="请选择结束日期"
                                    :picker-options="{disabledDate: disabledEndDate}">
                    </el-date-picker>
                  </div>
                  <div v-if="configInfo.current"
                       class="date-current">
                    <span class="theme-text"><i class="el-icon-warning-outline"></i></span>
                    <span>当前学期为：{{configInfo.current.name}}，学期起止时间：{{configInfo.current.startDate}}至{{configInfo.current.endDate}}</span>
                  </div>
                </el-form-item>
              </el-form>
            </div>
            <div class="config-form">
              <div class="title">
                <span class="theme-text">选择范围设置(不选表示不限制)</span>
              </div>
              <el-form size="mini"
                       label-width="90px">
                 <!-- 教学点选择 -->
                 <el-form-item label="教学点">
                   <div class="checkbox-group-container">
                     <div class="checkbox-list" :class="{ 'expanded': siteExpanded }">
                       <el-checkbox-group v-model="selectedSiteList">
                         <el-checkbox v-for="site in siteList"
                                      :key="site.id"
                                      :label="site.id">
                           {{ site.name }}
                         </el-checkbox>
                       </el-checkbox-group>
                     </div>
                     <div v-if="siteList.length > 6" class="expand-btn" @click="toggleSiteExpand">
                       <span v-if="!siteExpanded">展开更多 ({{ siteList.length - 6 }})</span>
                       <span v-else>收起</span>
                     </div>
                   </div>
                 </el-form-item>

                 <!-- 年级选择 -->
                 <el-form-item label="年级">
                   <div class="checkbox-group-container">
                     <div class="checkbox-list" :class="{ 'expanded': gradeExpanded }">
                       <el-checkbox-group v-model="selectedGradeList">
                         <el-checkbox v-for="grade in gradeList"
                                      :key="grade.id"
                                      :label="grade.id">
                           {{ grade.name }}
                         </el-checkbox>
                       </el-checkbox-group>
                     </div>
                     <div v-if="gradeList.length > 6" class="expand-btn" @click="toggleGradeExpand">
                       <span v-if="!gradeExpanded">展开更多 ({{ gradeList.length - 6 }})</span>
                       <span v-else>收起</span>
                     </div>
                   </div>
                 </el-form-item>

                 <!-- 学籍年级选择 -->
                 <el-form-item label="学籍年级">
                   <div class="checkbox-group-container">
                     <div class="checkbox-list" :class="{ 'expanded': statusGradeExpanded }">
                       <el-checkbox-group v-model="selectedStatusGradeList">
                         <el-checkbox v-for="statusGrade in statusGradeList"
                                      :key="statusGrade.id"
                                      :label="statusGrade.id">
                           {{ statusGrade.name }}
                         </el-checkbox>
                       </el-checkbox-group>
                     </div>
                     <div v-if="statusGradeList.length > 6" class="expand-btn" @click="toggleStatusGradeExpand">
                       <span v-if="!statusGradeExpanded">展开更多 ({{ statusGradeList.length - 6 }})</span>
                       <span v-else>收起</span>
                     </div>
                   </div>
                 </el-form-item>

                <!-- 学号模糊匹配 -->
                <el-form-item label="学号匹配">
                  <div class="input-container">
                    <el-input v-model="regNoPattern"
                              placeholder="请输入学号，支持*通配符"
                              clearable>
                    </el-input>
                    <div class="input-tip">
                      <span class="tip-text">* 表示通配符，如：23* 表示以23开头的学号, *23 表示23结尾的学号, *23* 表示包含23的学号, 23 表示学号为23的学号;
                        多个学号使用英文逗号,隔开;</span>
                    </div>
                  </div>
                </el-form-item>
              </el-form>
            </div>
            <div class="config-form">
              <div class="title">
                <span class="theme-text">一、录入学籍注册说明</span>
                <span>（必填项，学生进行学籍注册前必读内容，可录入导学规定等内容）</span>
              </div>
              <el-form size="mini">
                <el-form-item>
                  <AmEditor v-model="form.handbook"
                            :editor-height="260"></AmEditor>
                </el-form-item>
              </el-form>
            </div>
            <div class="config-form">
              <div class="title">
                <span class="theme-text">二、设置校验规则</span>
              </div>
              <el-form size="mini"
                       label-width="72px"
                       label-suffix="：">
                <el-form-item label="手机校验">
                  <el-checkbox v-model="form.mobilePhoneCheck"
                               true-label="1"
                               false-label="0">启用手机验证码校验</el-checkbox>
                </el-form-item>
              </el-form>
            </div>
            <div class="config-form">
              <div class="title">
                <span class="theme-text">三、录入提示信息</span>
                <span>（该提示信息将展示在信息填写页面，您可填入联系方式等提示内容）</span>
              </div>
              <el-form size="mini">
                <el-form-item>
                  <AmEditor v-model="form.tipWords"
                            :editor-height="260"></AmEditor>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </AppScrollbar>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>新生注册设置加载失败</div>
        <el-button type="text"
                   @click="loadConfigInfo">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import moment from 'moment'
import AppScrollbar from '../../../../../../elements/AppScrollbar'
import AmEditor from '../../../../../../elements/editor/AmEditor'
import Hint from '../../../../../../elements/Hint'
export default {
  name: 'StatusRegisterConfigMain',
  components: {
    AppScrollbar,
    AmEditor,
    Hint
  },
  data () {
    return {
      loading: false,
      configInfo: null,
      form: {
        checked: '',
        startDate: '',
        endDate: '',
        handbook: '',
        mobilePhoneCheck: '',
        tipWords: ''
      },
      // 选择范围数据
      siteList: [],
      gradeList: [],
      statusGradeList: [],
      // 提交数据
      selectedSiteList: [],
      selectedGradeList: [],
      selectedStatusGradeList: [],
      regNoPattern: '',
      // 展开状态
      siteExpanded: false,
      gradeExpanded: false,
      statusGradeExpanded: false
    }
  },
  computed: {
    getStartDate () {
      if (this.form.startDate) {
        return moment(this.form.startDate, 'YYYY-MM-DD').toDate()
      }
    },
    getEndDate () {
      if (this.form.endDate) {
        return moment(this.form.endDate, 'YYYY-MM-DD').toDate()
      }
    }
  },
  methods: {
    loadConfigInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/status/register/apply/configInfo',
        method: 'post'
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.configInfo = response.data['configInfo'] || {}
              this.gradeList = response.data['gradeList'] || {}
              this.statusGradeList = response.data['gradeList'] || {}
              this.siteList = response.data['siteList'] || {}
              this.$emit('ready')
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    disabledStartDate (date) {
      let getEndDate = this.getEndDate
      if (getEndDate) {
        return date.getTime() > getEndDate.getTime()
      }
      return false
    },
    disabledEndDate (date) {
      let getStartDate = this.getStartDate
      if (getStartDate) {
        return date.getTime() < getStartDate.getTime()
      }
      return false
    },
    getConfigInfo () {
      return new Promise((resolve, reject) => {
        if (this.form.checked === '1') {
          if (!this.form.startDate) {
            reject(new Error('请设置注册开始时间'))
            return
          }
          if (!this.form.endDate) {
            reject(new Error('请设置注册结束时间'))
            return
          }
          if (!this.form.handbook) {
            reject(new Error('请录入学籍注册说明'))
            return
          }
        }
        // 构建完整的配置数据
        const configData = {
          ...this.form,
          arrangeRegNo: this.regNoPattern || null,
          arrangeSite: this.selectedSiteList.length > 0 ? this.selectedSiteList.join(',') : null,
          arrangeGrade: this.selectedGradeList.length > 0 ? this.selectedGradeList.join(',') : null,
          arrangeStatusGrade: this.selectedStatusGradeList.length > 0 ? this.selectedStatusGradeList.join(',') : null
        }
        resolve(configData)
      })
    },
    // 展开/收起方法
    toggleSiteExpand () {
      this.siteExpanded = !this.siteExpanded
    },
    toggleGradeExpand () {
      this.gradeExpanded = !this.gradeExpanded
    },
    toggleStatusGradeExpand () {
      this.statusGradeExpanded = !this.statusGradeExpanded
    }
  },
  mounted () {
    this.loadConfigInfo()
  },
  watch: {
    configInfo: function (val) {
      if (val) {
        Object.keys(this.form).forEach(key => {
          this.form[key] = val[key] || ''
        })
        // 解析选择范围数据
        if (val.arrangeRegNo) {
          this.regNoPattern = val.arrangeRegNo
        }
        if (val.arrangeSite) {
          this.selectedSiteList = val.arrangeSite.split(',')
        }
        if (val.arrangeGrade) {
          this.selectedGradeList = val.arrangeGrade.split(',')
        }
        if (val.arrangeStatusGrade) {
          this.selectedStatusGradeList = val.arrangeStatusGrade.split(',')
        }
      }
    }
  }
}
</script>

<style lang="scss">
  @import "../../../../../../../styles/color";
  .status-register-config-main {
    height: 100%;
    .main-cont {
      margin: auto;
      width: 600px;
      max-width: 100%;
      padding: 30px 15px;
      box-sizing: border-box;
      & > .setup-info {
        & > .check-cont {
          .el-checkbox {
            & > .el-checkbox__label {
              font-size: 13px;
              vertical-align: -1px;
            }
          }
        }
        & > .steps-cont {
          margin-top: 20px;
          ul {
            list-style: none;
            margin: 0;
            padding: 0;
            & > li {
              color: #606266;
              font-size: 12px;
              & + li {
                margin-top: 6px;
              }
            }
          }
        }
      }
      & > .config-info {
        margin-top: 20px;
        color: #606266;
        & > .config-form {
          border-top: 1px solid #ebeef5;
          padding-top: 20px;
          & > .title {
            font-size: 12px;
            margin-bottom: 15px;
          }
          & + .config-form {
            margin-top: 15px;
          }
        }
        .el-form {
          margin-top: 10px;
          .el-form-item {
            margin-bottom: 0px;
            &.required {
              .el-form-item__label {
                position: relative;
                &:before {
                  content: '*';
                  position: absolute;
                  left: -10px;
                  color: #f56c6c;
                }
              }
            }
            .el-form-item__label {
              color: #303133;
              font-size: 12px;
              text-align: left;
              white-space: nowrap;
            }
            .el-form-item__content {
              font-size: 12px;
              .el-checkbox {
                .el-checkbox__label {
                  color: #606266;
                  font-size: 12px;
                }
              }
              .date-range {
                display: table;
                width: 100%;
                & > .el-date-editor {
                  display: table-cell;
                  width: 50%;
                }
                & > .divider {
                  display: table-cell;
                  width: 0;
                  padding-left: 10px;
                  padding-right: 10px;
                }
              }
              .date-current {
                margin-top: 5px;
                & > span {
                  &:first-child {
                    margin-right: 4px;
                    font-size: 14px;
                    font-weight: bold;
                  }
                }
              }
              // 选择范围样式
              .checkbox-group-container {
                .checkbox-list {
                  max-height: 60px;
                  overflow: hidden;
                  transition: max-height 0.3s ease;
                  &.expanded {
                    max-height: none;
                  }
                  .el-checkbox {
                    display: inline-block;
                    margin-right: 15px;
                    margin-bottom: 4px;
                    width: 120px;
                    vertical-align: top;
                    .el-checkbox__label {
                      font-size: 12px;
                      color: #606266;
                      line-height: 1.2;
                    }
                  }
                }
                .expand-btn {
                  cursor: pointer;
                  color: #409eff;
                  font-size: 12px;
                  padding: 4px 8px;
                  &:hover {
                    color: #66b1ff;
                  }
                }
              }
              .input-container {
                .input-tip {
                  margin-top: 5px;
                  .tip-text {
                    font-size: 11px;
                    color: #909399;
                  }
                }
              }
            }
          }
        }
      }
      .tip-msg {
        color: #909399;
      }
    }
  }
</style>
